import { Card, ListGroup } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { ERole } from 'types';
import { useApp } from 'app';

export const TutorialsTile = props => {

    const { highestRole } = useApp();
    const roleId = highestRole?.id;

    const showDistributorVideo = roleId === ERole.DISTRIBUTOR;

    return (
        <Card>
            <Card.Header className="text-uppercase">
                <strong>
                    {<FormattedMessage defaultMessage="Tutorials and Resources" id="tutorials_and_resources.16ac8792" />}
                </strong>
            </Card.Header>
            <ListGroup variant="flush">

                <ListGroup.Item
                    action
                    active={false}
                    href="http://support.gmetrix.net"
                    rel="noreferrer"
                    target="_blank"
                >
                    <i className="fa-solid fa-circle-question me-2 text-muted" />
                    {<FormattedMessage defaultMessage="Support and Frequently Asked Questions" id="support_and_frequently_asked_questions.ed3d4af1" />}
                </ListGroup.Item>
                <ListGroup.Item
                    action
                    href="http://www.gmetrix.net/download"
                    rel="noreferrer"
                    target="_blank"
                >
                    <i className="fa-solid fa-download me-2 text-muted" />
                    {<FormattedMessage defaultMessage="Download GMetrix SMS" description="Dashboard Form" id="download_gmetrix_sms.cbad7962" />}
                </ListGroup.Item>
            </ListGroup>
        </Card>
    );

};
